import React, { useRef } from "react";
import "./contact.css";
import { MdOutlineEmail } from "react-icons/md";
import { RiMessengerLine } from "react-icons/ri";
import { BsWhatsapp } from "react-icons/bs";
import emailjs from "emailjs-com";

const Contact = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_2nhp58s",
        "template_cs3h5i8",
        form.current,
        "user_vrOwfIYVfUet8smM628GH"
      )
      .then(
        (result) => {
          console.log(result.text);
        },
        (error) => {
          console.log(error.text);
        }
      );
    e.target.reset();
  };

  return (
    <section id="contact">
      <h5>Get In Touch</h5>
      <h2>Contact Me</h2>
      <div className="container contact__container">
        {/* START CONTACT OPTIONS  */}
        <div className="contact__options">
          <article
            className="contact__option"
            data-aos="fade-right"
            data-aos-duration="1000"
          >
            <MdOutlineEmail className="contact__option-icon" />
            <h4>Email</h4>
            <h5>geoalbert123@gmail.com</h5>
            <a href="mailto:geoalbert123@gmail.com" target="_blank">
              Send Email
            </a>
          </article>
          <article
            className="contact__option"
            data-aos="fade-right"
            data-aos-duration="1000"
            data-aos-delay="150"
          >
            <RiMessengerLine className="contact__option-icon" />
            <h4>Messenger</h4>
            <h5>George Albert</h5>
            <a
              href="https://m.me/georginio.albert"
              target="_blank"
              rel="noreferrer"
            >
              Send Message
            </a>
          </article>
        </div>
        {/* END CONTACT OPTIONS  */}
        <form
          ref={form}
          onSubmit={sendEmail}
          data-aos="fade-left"
          data-aos-duration="1000"
          data-aos-delay="250"
        >
          <input
            type="text"
            name="name"
            placeholder="Your Full Name"
            required
          />
          <input type="email" name="email" placeholder="Your Email" required />
          <textarea
            name="message"
            placeholder="Your Message"
            rows="7"
            required
          ></textarea>
          <button type="submit" className="btn btn-primary">
            Send Message
          </button>
        </form>
      </div>
    </section>
  );
};

export default Contact;
